var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from "react";
import { Text, HStack, VStack } from "@reverb-ui/react";
import { useTranslation } from "react-i18next";
import { colors } from "@reverb-ui/tokens";
import { ProductBox } from "../components/product-box";
import { CommunitySpaceIcon, IClipsIcon, IonIcon, LiveIcon, RockContentIcon, TalentBlogIcon, HelpRockContentIcon, } from "@/shared/presentation/components/icons";
import GTNIcon from "@/assets/icons/gtn-icon.svg";
import { ProductContext } from "@/shared/presentation/context-api/providers/product";
import StudioIcon from "@/assets/icons/studio-logo.svg";
import StageIcon from "@/assets/icons/stage-logo.svg";
var getProductUrl = {
    rc1: "https://plataforma.rockcontent.com",
    rc2: "https://studio.rockcontent.com",
    studio: "https://studio.rockcontent.com",
    ion: "https://ion.rockcontent.com",
    "global talent network": "https://gtn.rockcontent.com",
    live: "https://live.rockcontent.com",
    stage: "https://stage.rockcontent.com",
    iclips: "https://studio.rockcontent.com",
};
var getRockPlatforms = function (platforms) {
    return platforms.filter(function (platform) {
        var rockPlatforms = [
            "rc2",
            "ion",
            "global talent network",
            "live",
            "stage",
            "iclips",
            "studio",
        ];
        return rockPlatforms.includes(platform.name.toLowerCase());
    });
};
var getProductIconByCode = {
    studio: React.createElement(StudioIcon, null),
    rc1: React.createElement(StudioIcon, null),
    rc2: React.createElement(StudioIcon, null),
    stage: React.createElement(StageIcon, null),
    "global talent network": React.createElement(GTNIcon, null),
    ion: React.createElement(IonIcon, null),
    live: React.createElement(LiveIcon, null),
    iclips: React.createElement(IClipsIcon, null),
};
export var EasyAccessContainer = function (_a) {
    var isRocker = _a.isRocker, isTalent = _a.isTalent, user = _a.user;
    var t = useTranslation("home").t;
    var entityWalletPlatforms = useContext(ProductContext).entityWalletPlatforms;
    var HStackProps = {
        gridGap: "3",
        alignItems: "start",
        w: "full",
    };
    var renderPlatforms = function () {
        var platforms = entityWalletPlatforms.flat();
        return (React.createElement(HStack, __assign({}, HStackProps), platforms.map(function (platform) {
            var name = platform.name, externalId = platform.externalId, entityPlatformId = platform.entityPlatformId, externalName = platform.externalName;
            var platformName = name.toLowerCase().split(" ")[0];
            var descriptionKey = platformName.includes("studio")
                ? "products.studio"
                : "products." + platformName;
            var platformLink = getPlatformLink(externalId, name);
            return (React.createElement(ProductBox, { key: entityPlatformId, name: externalName || platformName, icon: getProductIconByCode[platformName], href: platformLink, description: t(descriptionKey) }));
        })));
    };
    var getPlatformLink = function (externalId, platformName) {
        var islink = externalId.includes("/") || externalId.includes(".com");
        var isID = !!(externalId && Number(externalId));
        if (!externalId || !islink || isID) {
            return null;
        }
        var hasHttp = externalId.includes("https") || externalId.includes("http");
        if (!hasHttp) {
            return "https://" + externalId;
        }
        return externalId;
    };
    return (React.createElement(VStack, { spacing: 4, alignItems: "flex-start", mt: 8 },
        React.createElement(Text, { fontSize: "md", color: colors.gray[800] }, t("easy-access")),
        renderPlatforms(),
        React.createElement(HStack, __assign({}, HStackProps), isTalent && (React.createElement(React.Fragment, null,
            React.createElement(ProductBox, { name: "Global Talent Network", icon: React.createElement(RockContentIcon, { dynamicColor: colors.blue[400] }), href: process.env.GTN_URL, description: t("gtn-desc") }),
            React.createElement(ProductBox, { name: "Talent Blog", icon: React.createElement(TalentBlogIcon, null), href: process.env.TALENT_BLOG_URL, description: t("talent-blog-desc") }),
            React.createElement(ProductBox, { name: "Community Space", icon: React.createElement(CommunitySpaceIcon, null), href: process.env.COMMUNITY_SPACE_URL, description: t("community-space-desc") }),
            React.createElement(ProductBox, { name: "Help Rock Content", icon: React.createElement(HelpRockContentIcon, null), href: process.env.HELP_URL, description: t("help-rock-content") })))),
        React.createElement(HStack, __assign({}, HStackProps), !isTalent &&
            getRockPlatforms(user.platforms).map(function (platform) {
                var _a, _b;
                return (React.createElement(ProductBox, { key: platform.id, name: "", description: platform.description, icon: getProductIconByCode[((_a = platform.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || React.createElement(RockContentIcon, null)], href: getProductUrl[(_b = platform.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()] }));
            })),
        React.createElement(HStack, __assign({}, HStackProps), isRocker && (React.createElement(React.Fragment, null,
            React.createElement(ProductBox, { name: "RockOS", icon: React.createElement(RockContentIcon, null), href: process.env.OS_URL }),
            React.createElement(ProductBox, { name: "RC1", icon: React.createElement(RockContentIcon, null), href: process.env.RC1_URL }))))));
};
